import { defineStore } from 'pinia'
import {
  PostMarkSiteDomainDetails,
  SFTPSSHCreds,
  SiteBackupsInfo,
  SiteGeneralInfo,
  SiteInfo,
  SiteResourceInfo,
  SiteWpCore,
  SiteWpPlugin,
  SiteWpTheme,
} from '@/models/site'
import { SiteSchedules } from '@/models/siteSchedules'

interface SiteStoreState {
  sites: SiteGeneralInfo[]
  selectedSite: {
    siteId?: number
    details: {
      general?: SiteGeneralInfo
      info?: SiteInfo
      resources?: SiteResourceInfo
      sftpSshCreds?: SFTPSSHCreds
      backups: SiteBackupsInfo
      dbLoginUrl?: string
      psi?: any
    }
    wordpress: {
      adminLoginUrl?: string
      themes: SiteWpTheme[]
      cores: SiteWpCore[]
      plugins: SiteWpPlugin[]
    }
  }
  currentSitePostmarkDomainDetails?: PostMarkSiteDomainDetails
  selectedSiteScheduleDetails?: SiteSchedules
  totalSitesCountOfUserIncludingDeleted?: number
}

export const useSitesStore = defineStore('sites', {
  state: (): SiteStoreState => {
    return {
      sites: [],
      selectedSite: {
        siteId: undefined,
        details: {
          general: undefined,
          info: undefined,
          resources: undefined,
          sftpSshCreds: undefined,
          dbLoginUrl: undefined,
          backups: {
            fileSystem: [],
            databaseSystem: [],
          },
        },
        wordpress: {
          adminLoginUrl: undefined,
          themes: [],
          cores: [],
          plugins: [],
        },
      },
      currentSitePostmarkDomainDetails: undefined,
      selectedSiteScheduleDetails: undefined,
    }
  },
  getters: {
    siteById: (state) => (id: string) => {
      return state.sites.find((site: any) => site.id === id)
    },
    selectedSiteDetails: (state) => {
      return state.selectedSite?.details
    },
    selectedSiteWordpressDetails: (state) => {
      return state.selectedSite?.wordpress
    },
    searchedSites: (state) => {
      return (searchQuery: string): SiteGeneralInfo[] | undefined => {
        return state.sites
        //   .filter((site: any) => {
        //   return (
        //     site.domain?.length &&
        //     site.domain[0]?.domain
        //       ?.toLowerCase()
        //       .includes(searchQuery.toLowerCase())
        //   )
        // })
      }
    },
    selectedSiteDomains: (state) => {
      return state.selectedSite?.details?.general?.domain || []
    },
    selectedSiteId: (state) => {
      return state.selectedSite?.siteId
    },
    getCurrentSitePostmarkDomainDetails: (state) => {
      return state.currentSitePostmarkDomainDetails
    },
    getSelectedSiteScheduleDetails: (state) => {
      return state.selectedSiteScheduleDetails
    },
    getSelectedSiteScheduleCover: (state) => {
      return state.selectedSiteScheduleDetails?.site?.siteReportingOptions
        ?.report_cover_url
    },
  },
  actions: {
    setSites(sites: SiteGeneralInfo[]) {
      this.sites = sites
    },
    setSelectedSiteId(siteId?: number) {
      this.selectedSite.siteId = siteId
    },
    setCurrentSitePostmarkDomainDetails(
      domainDetails: PostMarkSiteDomainDetails,
    ) {
      this.currentSitePostmarkDomainDetails = domainDetails
    },
    removeDomain(id: number) {
      this.selectedSite!.details!.general!.domain =
        this.selectedSite?.details?.general?.domain?.filter(
          (domain) => domain.id !== id,
        )
    },
    toggleSiteEdgeCache(status: boolean) {
      this.selectedSite = {
        ...this.selectedSite,
        details: {
          ...this.selectedSite.details,
          info: {
            ...this.selectedSite.details.info,
            edgeCache: status,
          },
        },
      }
    },
    setSelectedSiteScheduleDetails(scheduleDetails: SiteSchedules) {
      this.selectedSiteScheduleDetails = scheduleDetails
    },
    clearSites() {
      this.sites = []
    },
  },
})
